module.exports = __webpack_public_path__ + "static/media/te.3a8b9eca.png";